import { render } from "./Evaluate.vue?vue&type=template&id=44b22657"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"

import "./Evaluate.vue?vue&type=style&index=0&id=44b22657&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__